var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_vm._v("欢迎光临")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }